import React, { useRef } from "react";
import "./Foodbeveragespromotions.css";
import Overview from "./Overview.jsx";

const Promotionsmainpage = () => {
    const containerRef = useRef(null);

    return (
        <div
            className="company-container"
            ref={containerRef}
            style={{ marginTop: "-29px" }}
        >
            {/* Directly display Overview */}
            <div style={{height:"85vh", overflow:"auto", scrollbarWidth:"none"}} className="component-display-data">
                <Overview title="Campaign Overview" />
            </div>

        </div>
    );
};

export default Promotionsmainpage;